<span class="flex items-center">
  <span *ngFor="let star of stars" class="ig-star ig-star-on"></span>
  <!-- <span *ngIf="lastHalf" class="ig-star ig-star-half"></span> -->
  <img *ngIf="lastHalf" src="https://iti-images.s3.amazonaws.com/imgs/start-half.png"
    class="w-[19px] h-[19px] relative left-[2px] top-[2px] inline" />
</span>